import React from 'react';
import '../styles/MissionVision.css';
// import missionImg from '../Assets/Images/mission.png';
// import visionImg from '../Assets/Images/vision.png';
// import valueImg from '../Assets/Images/values.png'; // <-- Add an image for value

import missionImg from '../Assets/Images/photo-placeholder.png';
import visionImg from '../Assets/Images/photo-placeholder.png';
import valueImg from '../Assets/Images/photo-placeholder.png';

function MissionVision() {
  return (
    <section className="mission-vision-section">
      <div className="mv-container">
        <h2 className="mv-title">OUR VISION, MISSION & VALUE</h2>

        <div className="mv-cards">

          <div className="mv-card vision">
            <img src={visionImg} alt="Our Vision" className="mv-image" />
            <h3>Our Vision</h3>
            <p>
              To be a nationally admired and globally respected conglomerate by continually leading through
              innovation, customer focus, and responsible business practices.
            </p>
          </div>

          <div className="mv-card mission">
            <img src={missionImg} alt="Our Mission" className="mv-image" />
            <h3>Our Mission</h3>
            <p>
              To provide innovative, sustainable, and quality products across all industries we serve,
              while upholding the values of integrity, responsibility, and excellence in everything we do.
            </p>
          </div>

          <div className="mv-card value">
            <img src={valueImg} alt="Our Value" className="mv-image" />
            <h3>Our Value</h3>
            <p>
              We believe in Integrity, Nurture, Sincerity, Positive Atitude and Fairness to our quality and sustainability.
              These core values shape our culture and guide our business decisions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionVision;
